module.exports = __webpack_public_path__ + "img/noti-rejected.c70cbd95.svg";